import { render } from "./register.vue?vue&type=template&id=816e5424&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=816e5424&lang=less&scoped=true"

import exportComponent from "F:\\LSDC\\trunk\\lsdc-delivery-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816e5424"]])

export default __exports__